export default __webpack_public_path__ + "media/GitHub.3b2b7813.svg";